<div *ngIf="uploadSetting && showFileType" style="padding: 0.375rem 0.75rem; text-align: left;">{{ label.uploadType }}<span class="extention">{{uploadSetting.ext}}</span></div>
<div class="qq-uploader-selector qq-uploader qq-gallery" attr.qq-drop-area-text="{{ label.dropAreaText }}" [style.cursor]="disabled? 'not-allowed':''">
  <input type="file" class="sr-only" [id]="name"  [multiple]="!single" (change)="fileInputOnChange($event)" #fileInput>
  <ul class="qq-upload-list" [class.deny]="disabled" *ngIf="uploadSetting">
    <li class="col-md-6 col-sm-6" *ngFor="let file of files" (click)="stopPropagation($event)">
      <ng-container *ngIf="file.url; else fileTmp">
        <a target="_blank" href="{{file.url}}">
          <ng-container *ngTemplateOutlet="fileTmp"></ng-container>
        </a>
      </ng-container>
      <ng-template #fileTmp>
        <div class="qq-thumbnail-wrapper">
          <img class="qq-thumbnail-selector" [src]="file.url" >
        </div>
        <div class="qq-file-name">
          <span class="qq-upload-file" title="{{file.name}}">{{file.name}}</span>
        </div>
        <!-- <br><span class="qq-upload-size">{{ file.size | fileSize }}</span> -->
        <div *ngIf="!file.id && file.progress > 0" class="progress">
          <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="file.progress"
          [attr.aria-valuenow]="file.progress"
          aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <button *ngIf="file.id" type="button" class="qq-btn qq-upload-delete" (click)="deleteFile($event, file)">
          <span aria-label="Delete" class="fa fa-trash"></span>
        </button>
      </ng-template>
    </li>
  </ul>
  <tm-loading [show]="loading"></tm-loading>
</div>
